<template>
  <div>
    <van-nav-bar @click-left="clickBack" title="进出时段申请" left-arrow />
    <van-form validate-first @submit="onSubmit">
      <div class="form-wrap">
        <van-field
          name="radio"
          label="选择人员"
          label-width="120"
          required
          size="large"
          readonly
          :rules="rules.childMessage"
        >
          <template #input>
            <van-checkbox-group
              v-model="form.childMessage"
              direction="horizontal"
              :disabled="childList.length == 1"
            >
              <van-checkbox
                :name="item"
                shape="square"
                v-for="(item, index) in childList"
                :key="index"
                style="margin: 0 0.5rem 0.5rem 0;"
                >{{ item.name }}</van-checkbox
              >
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field
          v-model="form.leaveBeginTime"
          label="开始时间"
          placeholder="点击选择"
          clickable
          readonly
          required
          is-link
          label-width="120"
          @click="clickTime('starttime')"
          :rules="rules.pickUpBeginTime"
          size="large"
        />
        <van-field
          v-model="form.leaveEndTime"
          label="结束时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          required
          label-width="120"
          :rules="rules.pickUpEndTime"
          @click="form.leaveBeginTime && clickTime('endtime')"
          size="large"
        />
        <van-field
          v-model="form.teacherName"
          label="审批人"
          placeholder="请选择审批人"
          size="large"
          clickable
          label-width="120"
          required
          readonly
          :rules="rules.teacherName"
          @click="$refs.interviewee.showiIntervieweePopup = true"
        />
        <van-field
          type="textarea"
          placeholder="请输入备注"
          label="原因"
          required
          label-width="120"
          v-model="form.remark"
          :rules="rules.reason"
          size="large"
        />
      </div>
      <div style="margin: 30px 16px;">
        <van-button
          round
          block
          :loading="btn_loading"
          :disabled="btn_loading"
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="startMinTime"
      :isFilter="false"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="endMinDate"
      :isFilter="false"
      :currentDate="endCurTime"
    />
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" />
  </div>
</template>

<script>
import Interviewee from '@/components/subScribePopup/interviewee'
import SelectTime from '@/components/subScribePopup/selectTime'
import moment from 'moment'
import { timeFormart } from '@/utils'
export default {
  components: {
    Interviewee,
    SelectTime,
  },
  mounted() {
    this.getAllChild()
  },
  data() {
    return {
      form: {},
      rules: {
        pickUpPerson: [
          {
            required: true,
            message: '请输入姓名',
          },
        ],
        pickUpPhone: [
          {
            required: true,
            message: '请输入手机号',
          },
        ],
        pickUpBeginTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'onChange',
          },
        ],
      },
      childList: [],
      endMinDate: '',
      btn_loading: false,
    }
  },
  computed: {
    startMinTime() {
      // moment().add(1, 'h'))
      return new Date()
    },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, 'h'))
    },
  },
  methods: {
    onSubmit() {
      this.btn_loading = true
      this.$https
        .saveAccess({
          ...this.form,
          schoolId: this.$store.state.schoolId,
          userId: this.$store.state.userId,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg)
            this.btn_loading = false
            return
          }
          this.$toast('成功')
          setTimeout(() => {
            this.btn_loading = false

            this.$router.go(-1)
            this.form = {}
          }, 1000)
        })
        .catch(() => {
          this.btn_loading = false
        })
    },
    clickBack() {
      this.$router.go(-1)
    },
    handleTimeStartConfirm(value) {
      console.log(value)
      this.$set(this.form, 'leaveBeginTime', value)
      this.endMinDate = new Date(value.replace(/-/g, '/'))
      this.$refs.starttime.showTimePopup = false
    },
    handleSelIntervieweeItem(item) {
      console.log(item)
      // 更新被访人id
      this.$set(this.form, 'teacherId', item.id)
      this.$set(this.form, 'teacherName', item.name)
      // this.$set(this.form, 'auditeDeptName', item.deptName)
      this.$refs.interviewee.showiIntervieweePopup = false
    },
    handleTimeEndConfirm(value) {
      this.$set(this.form, 'leaveEndTime', value)
      this.$refs.endtime.showTimePopup = false
    },
    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },
    async getAllChild() {
      const { code, data } = await this.$https.getAllChild({
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return
      }
      this.childList = data
      this.$set(this.form, 'childMessage', [data[0]])
      // this.$set(this.form, 'radio', data[0])
    },
  },
}
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
</style>
